module.exports = __webpack_public_path__ + "img/equipo_16-9_640.7db85501.webp";